export default "<router-outlet></router-outlet>\n<p-toast position=\"top-left\"></p-toast>";